<template>
    <div>
    <div class="prefooter">
        <div class="prefooter-text">
            Family-owned & operated since 1953
        </div>
        <div class="prefooter-text">
            99% in-stock rate & fast order processing
        </div>
        <div class="prefooter-text">
            Customer Support experts ready to help
        </div>
    </div>
    <footer :class="{'footer': true, 'compare-sticky-visible': compareStickyVisible && !isApiServer}">
        <div class="footer-first_row">
            <div class="footer-global_nav">
                <RothcoFooterLogo
                    alt="Company logo"
                    class="footer-logo"
                    aria-hidden="true"
                />
                <div class="footer-navigation_list">
                    <div class="headline-xs" role="heading" aria-level="3">Military</div>
                    <div class="footer-navigation_list-divider" aria-hidden="true"></div>
                    <div class="headline-xs" role="heading" aria-level="3">Tactical</div>
                    <div class="footer-navigation_list-divider" aria-hidden="true"></div>
                    <div class="headline-xs" role="heading" aria-level="3">Work</div>
                    <div class="footer-navigation_list-divider" aria-hidden="true"></div>
                    <div class="headline-xs" role="heading" aria-level="3">Outdoor</div>
                </div>
            </div>
            <div class="footer-social" role="navigation">
                <div class="footer-social_icons">
                    <RothcoCta
                        class="footer-social_icon"
                        v-for="link in socialMedia"
                        :key="link.label"
                        :id="link.label"
                        html-slotted
                        ctaType="a"
                        v-bind="getCtaLink(link)"
                        role="link"
                        :aria-label="`Visit our ${link.label} page`"
                    >
                        <component 
                            :is="link.icon" 
                            :alt="link.label" 
                            role="presentation" 
                            :aria-hidden="link.icon ? 'false' : 'true'" 
                        />
                    </RothcoCta>
                </div>
            </div>
        </div>

        <div class="footer-divider_desktop"></div>

        <div v-if="!isApiServer" class="footer-second_row">
            <div class="footer-menus">
                <div class="footer-menus_container">

                    <div v-for="(footerSection, index) of footerLinks" class="footer-menus_items" :key="`footer_section_${index}`" :id="`footer_section_${index}`">
                        <div class="footer-menu_item">
                            <div class="footer-menu_item-line" aria-hidden="true"></div>
                            <div class="footer-menu_container" role="navigation">
                                <input
                                    type="checkbox"
                                    class="footer-menu_input peer"
                                />
                                <h3 class="headline-xs" role="heading" aria-level="4">{{ footerSection.text }}</h3>
                                <div class="footer-accordion_item">
                                    <AccordionArrow
                                        alt="arrow"
                                    />
                                </div>
                                <div class="footer-desktop_list" role="navigation" :aria-label="`${footerSection.text} Links`">
                                    <Link v-for="(footerLink, footerLinkIndex) of footerSection.secondary" :href="getCtaLink(footerLink).href" 
                                        class="paragraph-details" :key="`footer_link_${footerLinkIndex}`" :id="`footer_link_${footerLinkIndex}`"
                                        :aria-label="footerLink.text"
                                        role="link" 
                                        >
                                        {{ footerLink.text }}
                                    </Link>
                                </div>
                            </div>
                            <div class="footer-menu_item-line" aria-hidden="true"></div>
                        </div>
                    </div>
                </div>
            </div>
            <FooterForm v-if="!isApiServer" />
        </div>

        <div v-if="!isApiServer" class="footer-divider_desktop"></div>

        <div class="footer-third_row">
            <div class="footer-third_row_container">
                <div class="footer-copytight_menu"
                    role="navigation" aria-label="Footer CopyRight Menu"
                >
                <a href="#" class="paragraph-details cky-banner-element">Cookie Settings</a>
                    <Link
                        v-for="{ text, id, url } in bottomLinks"
                        :id="id"
                        :key="id"
                        variant="secondary"
                        class="paragraph-details"
                        :href="url"
                        :aria-label="text"
                        role="link"
                    >
                        {{ text }}
                </Link>

                    <span class="footer-copytight_span paragraph-details"
                        >All Images and Descriptions © {{ currentYear }} Rothco</span
                    >
                </div>
                <span class="footer-copytight_span_mobile paragraph-details"
                    >All Images and Descriptions © {{ currentYear }} Rothco</span
                >
                
                <div class="language-container footer-language_container">
                    <GoogleTranslateDropdown />
                </div>
            </div>
        </div>
    </footer>
    </div>
</template>
<script lang="ts" setup>
    import instagramIcon from "@icons/social_instagram.svg";
    import facebookIcon from "@icons/social_facebook.svg";
    import twitterIcon from "@icons/social_twitter.svg";
    import youtubeIcon from "@icons/social_youtube.svg";
    import pinterestIcon from "@icons/social_pinterest.svg";
    import tiktokIcon from "@icons/social_tiktok.svg";
    import RothcoFooterLogo from "@icons/rothco-footer-logo.svg";
    import AccordionArrow from "@icons/accordion-arrow-white.svg";

    import { computed, inject, onMounted } from "vue";
    import { Link } from "@inertiajs/vue3"
    import { useSettingsStore } from "@/store/settings";
    import { useGenericStore } from "@/store/genericStore";
    import { storeToRefs } from "pinia";
    import FooterForm from "@/components/FooterForm.vue";
    import { getCtaLink } from "@/helpers/interfaces/Cta";
    import RothcoCta from "@/components/RothcoCta.vue";
    import GoogleTranslateDropdown from "@/components/GoogleTranslateDropdown.vue";

    const settings = useSettingsStore();
    let route = inject("route");
    let { footerLinks, socialLinks, is_dealer, isApiServer } = storeToRefs(settings);
    
    
    const socialMedia = computed(()=>{
        return socialLinks.value.map(link => {
            switch (link.profile) {
                case "Instagram":
                    return { label: link.profile, url: link.url ?? {}, icon: instagramIcon };
                case "Facebook":
                    return { label: link.profile, url: link.url ?? {}, icon: facebookIcon };
                case "X":
                    return { label: link.profile, url: link.url ?? {}, icon: twitterIcon };
                case "YouTube":
                    return { label: link.profile, url: link.url ?? {}, icon: youtubeIcon };
                case "Pinterest":
                    return { label: link.profile, url: link.url ?? {}, icon: pinterestIcon };
                case "TikTok":
                    return { label: link.profile, url: link.url ?? {}, icon: tiktokIcon };
                default:
                    return { label: link.profile, url: link.url ?? {}, icon: "" };
            }
        })
    });
    const bottomLinks = [
        {
            text: "Term & Conditions",
            id: "terms_and_conditions",
            url: route('index.cms', {pageName: 'rothco-terms-conditions'} )
        },
        {
            text: "Privacy Policy",
            id: "privacy_policy",
            url: route('index.cms', {pageName: 'rothco-privacy-policy'} )
        },
        {
            text: "Accessibility",
            id: "accessibility",
            url: route('index.cms', {pageName: 'rothco-accessibility'} )
        },
        {
            text: "Do Not Sell My Info",
            id: "do_not_sell_my_info",
            url: route('account.doNotSellMyInfo.show')
        }
    ];

    let currentYear = computed(() => new Date().getFullYear());

    let compareStickyVisible;
    onMounted(()=>{
        let compareStickyVisibleStore = useGenericStore('compareStickyVisible');
        let { state } = storeToRefs(compareStickyVisibleStore);
        compareStickyVisible = state;
    })
</script>

<style scoped>
    .footer-body {
        display: flex;
        flex-direction: row;
    }
    @media screen and (max-width: 767px) {
        .footer-body {
            display: flex;
            flex-direction: column;
        }
    }
</style>
